/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'townsquare-comments.comment-action-bar.delete-button': 'Odstranit',
  'townsquare-comments.comment-action-bar.edit-button': 'Upravit',
  'townsquare-comments.comment-action-bar.reply-button': 'Odpovědět',
  'townsquare-comments.comment.edited-date': 'upraveno {time}',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {Komentáře} one {{itemCount,number} komentář} few {{itemCount,number} komentáře} many {{itemCount,number} komentáře} other {{itemCount,number} komentářů}}',
};
